import { Box, Typography } from "@mui/material";

export const Item = (props: { label: string, value: any; }) => {
    return <Box sx={{
        display: 'flex',
    }}>
        <Typography
            sx={{
                fontSize: "16px",
                width: '45%',
                fontWeight: 'bold'
            }}
        >
            {props.label}:
        </Typography>

        <Typography
            sx={{
                fontSize: "16px",
                width: '55%',
            }}
        >
            {props.value}
        </Typography>
    </Box>;
};
